var map = {
	"app/client-management/client-management.module": [
		"./src/app/client-management/client-management.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-client-management-client-management-module"
	],
	"app/core/core.module": [
		"./src/app/core/core.module.ts"
	],
	"app/fresh-desk/fresh-desk.module": [
		"./src/app/fresh-desk/fresh-desk.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-fresh-desk-fresh-desk-module"
	],
	"app/inventory-details-dashboard/inventory-details-dashboard.module": [
		"./src/app/inventory-details-dashboard/inventory-details-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-inventory-details-dashboard-inventory-details-dashboard-module"
	],
	"app/inventory-planning-dashboard/inventory-planning-dashboard.module": [
		"./src/app/inventory-planning-dashboard/inventory-planning-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-inventory-planning-dashboard-inventory-planning-dashboard-module"
	],
	"app/movement-details-dashboard/components/agn-details/agn-details.module": [
		"./src/app/movement-details-dashboard/components/agn-details/agn-details.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"default~app-movement-details-dashboard-components-agn-details-agn-details-module~app-movement-detail~67b10372",
		"app-movement-details-dashboard-components-agn-details-agn-details-module"
	],
	"app/movement-details-dashboard/components/awb-details/awb-details.module": [
		"./src/app/movement-details-dashboard/components/awb-details/awb-details.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"default~app-movement-details-dashboard-components-awb-details-awb-details-module~app-movement-detail~d11ca126",
		"app-movement-details-dashboard-components-awb-details-awb-details-module"
	],
	"app/movement-details-dashboard/components/order-details/order-details.module": [
		"./src/app/movement-details-dashboard/components/order-details/order-details.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"default~app-movement-details-dashboard-components-order-details-order-details-module~app-movement-de~d1c8c4de",
		"app-movement-details-dashboard-components-order-details-order-details-module"
	],
	"app/movement-details-dashboard/movement-details-dashboard.module": [
		"./src/app/movement-details-dashboard/movement-details-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"default~app-movement-details-dashboard-components-agn-details-agn-details-module~app-movement-detail~67b10372",
		"default~app-movement-details-dashboard-components-order-details-order-details-module~app-movement-de~d1c8c4de",
		"default~app-movement-details-dashboard-components-awb-details-awb-details-module~app-movement-detail~d11ca126",
		"app-movement-details-dashboard-movement-details-dashboard-module"
	],
	"app/overall-status/overall-status.module": [
		"./src/app/overall-status/overall-status.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-overall-status-overall-status-module"
	],
	"app/performance-dashboard/performance-dashboard.module": [
		"./src/app/performance-dashboard/performance-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-performance-dashboard-performance-dashboard-module"
	],
	"app/pickup-request/pickup-request.module": [
		"./src/app/pickup-request/pickup-request.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-pickup-request-pickup-request-module"
	],
	"app/report-downlaod-dashboard/report-download.module": [
		"./src/app/report-downlaod-dashboard/report-download.module.ts",
		"app-report-downlaod-dashboard-report-download-module"
	],
	"app/request-tracker/request-tracker.module": [
		"./src/app/request-tracker/request-tracker.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-request-tracker-request-tracker-module"
	],
	"app/sales-forecast/sales-forecast.module": [
		"./src/app/sales-forecast/sales-forecast.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-sales-forecast-sales-forecast-module"
	],
	"app/transportation-dashboard/transportation-dashboard.module": [
		"./src/app/transportation-dashboard/transportation-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-transportation-dashboard-transportation-dashboard-module"
	],
	"app/user-management-dashboard/user-management-dashboard.module": [
		"./src/app/user-management-dashboard/user-management-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-user-management-dashboard-user-management-dashboard-module"
	],
	"app/warehouse-dashboard/warehouse-dashboard.module": [
		"./src/app/warehouse-dashboard/warehouse-dashboard.module.ts",
		"default~app-client-management-client-management-module~app-fresh-desk-fresh-desk-module~app-inventor~e8d32839",
		"app-warehouse-dashboard-warehouse-dashboard-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;